module.exports = __webpack_public_path__ + "static/media/regus.b4428bf1.png";